import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { BaseService } from '@kodit/core/services';
import {
  IzlazneFaktureClient,
  PredracunDto,
  PredracuniClient,
} from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PredracunDuplikatResolver
  extends BaseService
  implements Resolve<PredracunDto> {
  constructor(private _client: PredracuniClient, private _router: Router) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<PredracunDto> | Promise<PredracunDto> | PredracunDto | null {
    let id = 0;
    try {
      id = this._router.getCurrentNavigation().extras.state.id;
    } catch {
      return null;
    }

    return this._client.duplicatePredracun(id).pipe(
      map((res) => res.data),
      catchError(this.handleError),
      finalize(() => {
        //this._configService.setIsBusy = false;
      })
    );
  }
}
